export default __webpack_public_path__ + "static/media/ico_order_light.c9ec718c.svg";